import axios from "axios";
import { FlowTestMeasurementGroupResponse } from "../../../types/model/flowTestMeasurement";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/flow-tests`;

export const getFlowTestFlowTestMeasurements = async (
  flowTestId: number,
  variableId?: number,
  startDate?: string,
  endDate?: string,
  minTestingTime?: number,
  maxTestingTime?: number,
  sortBy?: string
): Promise<FlowTestMeasurementGroupResponse[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<FlowTestMeasurementGroupResponse[]>(
    `${BASE_URL}/${flowTestId}/measurements`,
    {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      params: { 
        variableId, 
        startDate, 
        endDate, 
        minTestingTime, 
        maxTestingTime, 
        sortBy
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};
